import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/DigitalTools/LogisticsExplorer/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Digital Tools', href: '/digital-tools' as Route },
            { title: 'Logistics Explorer', href: '' as Route },
          ]}
        />

        <Image
          className={cn('header__bg-ellipse')}
          src="/images/pages/DigitalTools/LogisticsExplorer/bg-ellipse-01.svg"
          alt="ellipse"
          width={300}
          height={100}
        />

        <div className={cn('header__info')}>
          <h1 className={cn('header__heading')}>
            {screenWidth < 1025 &&
              <>
                <span>Simplify Your Freight</span>{' '}
                <span>Calculations with Our Logistics</span>{' '}
                <span>Explorer Tool</span>
              </>
            }
            {screenWidth >= 1025 &&
              <>
                <span>Simplify Your</span>{' '}
                <span>Freight Calculations</span>{' '}
                <span>with Our Logistics</span>{' '}
                <span>Explorer Tool</span>
              </>
            }
          </h1>
          <p className={cn('header__description')}>
            Step into smarter shipping with Logistics Explorer, the 
            SeaRates Calculator built to simplify costs. We proudly 
            offer a cutting-edge tool, powered by SeaRates, that empowers 
            carriers and commerce-driven companies to compare shipping costs, 
            create instant quotes, and control freight flows with clarity.
          </p>
          <div className={cn('header__buttons')}>
            <Link
              className={cn('header__button-try')}
              href='https://www.searates.com/logistics-explorer/'
            >
              Try the Freight Rate Calculator Now
            </Link>
          </div>
        </div>

        <div className={cn('header__image-box')}>
          <picture>
            <source
              srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/application-mobile.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/application-mobile@2x.webp 2x
              "
              sizes="100vw"
              media="(max-width: 575px)"
            />
            <source
              srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/application-tablet.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/application-tablet@2x.webp 2x
              "
              sizes="100vw"
              media="(max-width: 1024px)"
            />
            <source
              srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/application-desktop.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/application-desktop@2x.webp 2x
              "
              sizes="100vw"
            />
            <img
              className={cn('header__image')}
              src="/images/pages/DigitalTools/LogisticsExplorer/application-desktop.webp"
              alt="ship schedules"
            />
          </picture>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;